RivalIQ.apps.SocialPosts.module('widgets', function (widgets, App, Backbone, Marionette, $, _) {

    'use strict';

    const Glance = RivalIQ.apps.Dashboard.views.ColumnWidgets.mixin({

        mixins: {
            PostTagsReload: App.mixins.PostTagsReload,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload
        },

        columnWidth: 3,
        panelView: undefined,
        className: 'panel-body glance-widget',

        dashboardModelEvents: {
            'change': 'reload'
        },

        getPngView: function (child) {
            return child.getView();
        },

        loadData: function (callback) {
            const me = this;

            const focusCompanyCount = me.dashboardModel.metric.build({
                property: 'count',
                dimensions: ['companyId'],
                companyId: me.getProp('focusCompanyId')
            });

            me._nonBlockingLoad = focusCompanyCount.fetch().done(function (metric) {
                me.postCount = metric;
            });

            // Call this callback immediately so that the child widgets will be rendered and their metric requests will be in
            // the same batch as this loadData. See #34843
            callback();
        },

        onRenderLoaded: function () {
            const me = this;
            me.toggleView();
        },

        toggleView: function () {
            const me = this;

            me._nonBlockingLoad
                .then(() => {
                    me.requestRenderedFrame(function () {
                        Marionette.CollectionView.prototype.render.call(me);
                    });
                });
        },

        isEmpty: function () {
            const me = this;

            if (!me.postCount) {
                return;
            }

            const focusCompanyHasPosts = me.postCount.getValue({
                format: false
            }) > 0;
            return (!focusCompanyHasPosts) ||
                RivalIQ.apps.Dashboard.views.ColumnWidgets.prototype.isEmpty.call(me);
        },

        // TODO this could be more efficient by not re-rendering
        refresh: function () {
            const me = this;
            me.render();
        },

        emptyView: Marionette.ItemView.extend({
            template: '#socialPostsNoFocusPosts'
        }),

        initialize: function () {
            const me = this;
            me.collection = me.dashboardModel.getWidgets();
        }
    });

    function hourFormatter(hour, metric) {
        if (_.isUndefined(hour)) {
            return '--';
        }

        const name = RivalIQ.utils.timezone.getTimezoneAbbreviation(metric.get('timezone'), metric.get('endDate'));
        return `${metric.byProperty('format', hour)} ${name}`;
    }

    function suffixFormatter(hour, metric) {
        if (_.isUndefined(hour)) {
            return '--';
        }

        const formatted = metric.byProperty('format', hour);
        // formatted will be a value such as '7pm', '12am' etc.
        // split the string into digits and non-digits
        const match = formatted.match(/(^\d+)([^\d].*$)/);

        const timezoneName = RivalIQ.utils.timezone.getTimezoneAbbreviation(metric.get('timezone'), metric.get('endDate'));
        if (match.length === 3) {
            return new RivalIQ.utils.metricValue(match[1], null, `${match[2]} ${timezoneName}`);
        } else {
            return new RivalIQ.utils.metricValue(formatted, null, timezoneName);
        }
    }

    function getWidgets(props) {

        const me = this;
        const metric = me.metric;
        const postWord = RivalIQ.data.channels.get(props.channel).get('postName');
        const audienceName = me.getProp('channel') === 'facebook' ? 'Page Fan' : 'Follower';

        return [
            {
                instanceId: 'posts-per-day',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    name: `Your ${_.capitalize(postWord)}s Per Day`,
                    description: RivalIQ.str('cross_channel_posts_per_day_description', postWord),
                    property: 'count / period',
                    companyId: props.focusCompanyId,
                    dimensions: ['companyId']
                }),
                submetric: metric.build({
                    property: 'count / period',
                    name: 'Landscape Avg.',
                    aggregate: 'average',
                    over: ['companyId']
                })
            },
            {
                instanceId: 'eng-rate',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    name: `Your Eng. Rate by ${audienceName}`,
                    abbreviatedName: 'Your Eng. Rate',
                    description: RivalIQ.str('social_posts_engagement_rate_by_follower', postWord, audienceName.toLocaleLowerCase(), audienceName),
                    companyId: props.focusCompanyId,
                    property: 'avg_engagement_rate_per_post',
                    dimensions: ['companyId']
                }),
                submetric: metric.build({
                    name: `${_.capitalize(postWord)} Avg.`,
                    property: 'avg_engagement_rate_per_post'
                })
            },
            {
                instanceId: 'hashtags',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    name: `Your ${_.capitalize(postWord)}s with Hashtags`,
                    description: RivalIQ.str('cross_channel_posts_with_hashtags_description', postWord),
                    property: 'with_hashtags / count',
                    companyId: props.focusCompanyId,
                    dimensions: ['companyId'],
                    valueFormat: RivalIQ.formatter.absolutePercent
                }),
                submetric: metric.build({
                    name: `${_.capitalize(postWord)} Avg.`,
                    property: 'with_hashtags / count',
                    valueFormat: RivalIQ.formatter.absolutePercent
                })
            },
            {
                instanceId: 'hours',
                widgetId: RivalIQ.enums.widgetTypes.METRIC,
                metric: metric.build({
                    name: 'Your Top Hour of Day',
                    description: RivalIQ.str('cross_channel_avg_engagement_rate_per_post_top_time_of_day_description', postWord),
                    companyId: props.focusCompanyId,
                    property: 'avg_engagement_rate_per_post',
                    dimensions: ['companyId'],
                    aggregate: 'max',
                    returns: 'name',
                    valueFormat: suffixFormatter,
                    over: ['hour']
                }),
                submetric: metric.build({
                    name: 'Landscape Top',
                    property: 'avg_engagement_rate_per_post',
                    aggregate: 'max',
                    valueFormat: hourFormatter,
                    returns: 'name',
                    over: ['hour']
                }),
                // These props are passed to metric rebuild in the RivalIQ.apps.Dashboard.widgets.MetricView::loadData.
                props: {
                    returns: 'name'
                }
            }
        ];
    }

    const Widget = RivalIQ.apps.Dashboard.models.Widget;
    const GlanceWidget = Widget.extend({
        title: function () {
            const me = this;
            const companyId = me.getProp('focusCompanyId');
            const company = RivalIQ.state.landscape.getCompanyById(companyId);
            const companyName = (company ? company.get('name') : '');
            return [companyName, 'at a Glance'].join(' ');
        },
        description: function () {
            const me = this;
            const postWord = RivalIQ.data.channels.get(me.getProp('channel')).get('postName');
            return RivalIQ.str('social_posts_glance_info', postWord, _.capitalize(postWord), postWord);
        },
        getExportTitle: App.utils.exportTitle,
        getExportSubtitle: App.utils.exportSubtitle,
        getPptSubtitle: App.utils.pptSubtitle,
        getSlideElements: App.utils.getSlideElements,
        view: Glance,
        pdfView: App.views.PdfPanel,
        pngView: App.views.PngPanel,
        viewMore: false,
        propsToSerializeForExport: App.utils.widgetExportProps,
        processProps: function (props) {
            const me = this;

            if (!me.metric) {
                me.metric = new RivalIQ.models.MetricDefinition({
                    concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS.id
                });
            }

            App.utils.updateMetric(me.metric, props);
            props.doNotRebuildMetrics = false;
            props.format = null;
            props.startDate = moment.utc(props.timePeriod.mainPeriodStart).format('YYYY-MM-DD');
            props.endDate = moment.utc(props.timePeriod.mainPeriodEnd).format('YYYY-MM-DD');

            return props;
        },
        widgetDefinitions: function () {
            const me = this;
            return getWidgets.call(me, me.getProps());
        },
        filter: function () {
            const me = this;
            return !RivalIQ.props.channelAccess(me.getProps());
        }
    });

    Marionette.Dashboard.widgets.add(RivalIQ.enums.widgetTypes.SOCIAL_POSTS_GLANCE, GlanceWidget);
});
